import React, { useContext, useEffect, useState } from "react";

import AuthContext from "../../context/AuthContext";

import "./MainSection.css";
import Container from "../../components/ui/Container";

import OffsetButton from "../../components/ui/Buttons/OffsetButton";
import { ReactComponent as Cloud } from "../../assets/sahaba-assets/iconBtn.svg";
import sahabaHeroImg from "../../assets/sahaba-assets/HeroSection.png";
import Pattern from "../../assets/sahaba-assets/rainPattern.png";

import "./Heroimage.css";

import { ReactComponent as TextDecore } from "../../assets/monqez-assets/scratch.svg";
const MainSection = ({ title = "", id = 0 }) => {
    const { token } = useContext(AuthContext);

    return (
        <>
            <section className="md:h-screen min-h-screen negative-nav-margin relative overflow-hidden">
                <div className="w-screen h-96 overflow-hidden -top-28 absolute z-0">
                    {/* Pattern Background */}

                    <div className="h-28 absolute w-full bg-primary-container opacity-70 z-10 smooth" />
                    <div
                        className="h-full w-full z-0 opacity-30 dark:opacity-20 smooth"
                        style={{
                            backgroundImage: `url(${Pattern})`,
                            backgroundSize: "contain",
                            backgroundPosition: "center center",
                            backgroundRepeat: "repeat-x",
                        }}
                    ></div>
                </div>
                <div className="w-screen h-96 overflow-hidden -bottom-20 absolute z-0">
                    {/* Pattern Background */}

                    <div className="h-28 absolute w-full bg-primary-container opacity-70 z-10 smooth" />
                    <div
                        className="h-full w-full z-0 opacity-30 dark:opacity-20 smooth"
                        style={{
                            backgroundImage: `url(${Pattern})`,
                            backgroundSize: "contain",
                            backgroundPosition: "center center",
                            backgroundRepeat: "repeat-x",
                        }}
                    ></div>
                </div>
                <Container className="h-full relative z-10 font-fs pt-32 md:pt-0 pb-20 md:pb-0">
                    <div className="w-full flex md:flex-row-reverse flex-col h-full space-y-10 md:space-y-0   ">
                        <div className="md:basis-1/2 px-0 md:px-10 basis-full h-full flex-center-both">
                            <div className="flex md:items-start items-center justify-center flex-col space-y-6 md:space-y-0 font-graphic">
                                <div className="relative">
                                    <div className="relative z-10 ">
                                        <div className="pt-3">
                                            <h1 className="relative text-moonBlue-700 dark:text-moonBlue-200 smooth ">
                                                <span className="font-voxo  text-center md:text-right flex flex-col space-y-1 leading-[.9] font-w-bold text-[3rem] md:text-[4rem]">
                                                    <span>سحابة ؟ هتتعلم</span>

                                                    <span className="-mt-2">بسهولة</span>
                                                </span>
                                            </h1>
                                        </div>
                                    </div>
                                </div>

                                <div className="pt-4 text-center md:text-right text-xl md:text-2xl w-3/4 text-gray-600 dark:text-gray-200 smooth space-y-2 font-lama">
                                    سحابة هي{" "}
                                    <span className="clr-text-primary smooth">
                                        رحلتك إلى سحابة المعرفة
                                    </span>{" "}
                                    حيث نقدم لك محتوى تعليمي متكامل لطلاب الثانوية العامة. انضم
                                    إلينا لتجد دروساً
                                </div>

                                <div className=" pt-10 md:pb-0  ">
                                    <OffsetButton
                                        color="moonBlue"
                                        className="flex-center-both text-lg gap-4"
                                        to={!token ? `/register` : "/me/user/courses"}
                                    >
                                        <Cloud className="mb-1 w-7 h-full fill-moonBlue-700 dark:fill-moonBlue-200 smooth " />
                                        {!token ? "أبدا رحلتك التعليمية" : " كورساتي"}
                                    </OffsetButton>
                                </div>
                            </div>
                        </div>
                        <div className="md:basis-1/2 basis-full h-full flex-center-both pt-10 md:pt-0">
                            <div className="flex-center-both max-w-3xl px-4 sm:px-20">
                                {/* <img src={HeroImg} alt={"profile"} className="w-full h-full" /> */}
                                <img src={sahabaHeroImg} alt={"profile"} className="" />
                            </div>
                        </div>
                    </div>
                </Container>
            </section>
        </>
    );
};

export default MainSection;
